import { findStructAllInfo, saveDefine } from '@/api/device'
const state = {
  showDefinition: false,
  definitionForm: {},
  definitionMap: {},
}

const actions = {
  async reverseDefinitionStatus({ commit }, status) {
    commit('REVERSE_DEFNITION_STATUS', status)
  },
  async setTypeId({ commit, state }, typeId) {
    let form = Object.assign({}, state.definitionForm);
    form.deviceTypeId = typeId;
    commit('SET_FORM', form);
  },
  async saveDefinition({ commit }, form) {
    let formData = Object.assign({}, form);
    formData.type = 'editor';
   
    const res = await saveDefine(formData);
    if (res.code == 200) {
      const data = res.data._id ? res.data : formData;
      commit('SET_FORM', {});
      commit('REVERSE_DEFNITION_STATUS', false);
      commit('SET_MAP_ITEM', data)
      this.commit('global/SHOW_SNACKBAR', { color: 'success', text: '操作成功' })
    }
  },
  async loadData({ commit }, sceneId) {
    const res = await findStructAllInfo({ sceneId, type: 'editor' })
    if (res.code == 200) {
      const definitionMap = res.data.reduce((pre, next) => {
        pre[next.structId] = next
        return pre
      }, {})
      commit('SET_MAP_DATA', definitionMap)
    }
  },
  checkStruct({ commit, state }, { structId, modelName }) {
    const form = state.definitionMap[structId] ?? { structId, name: modelName };
    commit('SET_FORM', form);
  }
}

const mutations = {
  REVERSE_DEFNITION_STATUS(state, status) {
    state.showDefinition = status;
  },
  SET_MAP_ITEM(state, definitionData) {
    state.definitionMap[definitionData.structId] = definitionData;
  },
  SET_MAP_DATA(state, dataMap) {
    state.definitionMap = dataMap;
  },
  SET_FORM(state, form) {
    state.definitionForm = form;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
